import {Component, OnInit} from '@angular/core';
import {ConfigurationService} from "../services/configuration.service";
import {NotificationsService} from "angular2-notifications";
import {UserService} from "../services/user.service";
import {AssetsService} from "../services/assets.service";
import {Router} from "@angular/router";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {Globals} from "../app-globals";
import {AdminService} from "../services/admin.service";
import {KycserviceService} from "../services/kycservice.service";

@Component({
    selector: 'app-kycplans',
    templateUrl: './kycplans.component.html',
    styleUrls: ['./kycplans.component.css']
})
export class KycplansComponent implements OnInit {
    plansList = [];
    planListFlag = false;
    showform = 'view';
    credentials = {
        title: '',
        order: 1,
        features: {},
        requirements: {},
        deposit_limit: false,
        deposit_limit_unlimited: true,
        deposit_limit_overall: null,
        deposit_limit_daily: null,
        deposit_limit_monthly: null,
        withdraw_limit: false,
        withdraw_limit_unlimited: true,
        withdraw_limit_overall: null,
        withdraw_limit_daily: null,
        withdraw_limit_monthly: null,
        _id: '',
        _csrf: ''
    };
    /*
        deposit_fee_charges: null,
        deposit_fee_apply: 'percent',
        withdraw_fee_charges: null,
        withdraw_fee_apply: 'percent',
     */
    formlabel = 'Create Plan';
    permission: String;
    customer: Boolean;
    /*requirements: {
        1: ['Full Name', 'Email Address', 'Primary Address', 'Phone Number'],
        2: ['Government Issued ID', 'Proof of residence', 'ID Confirmation Photo', 'Occupation'],
        3: ['Financial statements', 'AML verification']
    }
    features: {
        1: ['Deposit & withdraw digital assets', 'Buy/sell/trade digital assets'],
        2: ['Deposit & withdraw digital assets', 'Buy/sell/trade digital assets'],
        3: ['Personalized Funding Limits', 'Higher margin limits', 'Over-the-counter trading']
    }*/
    features = [1];
    requirements = [1];
    maxFeature = 1;
    maxRequirements = 1;
    maxLevel = 1;

    constructor(private configService: ConfigurationService,
                private notifSer: NotificationsService,
                private userService: UserService,
                private assetService: AssetsService,
                private spinnerService: Ng4LoadingSpinnerService,
                private router: Router,
                private global: Globals,
                private adminService: AdminService,
                private kycService: KycserviceService) {
    }

    ngOnInit() {
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            this.adminService.groupupdate.subscribe(permData => {
                localStorage.setItem('permission', permData.permission);
                this.permission = permData.permission
            })
            this.permission = this.adminService.getPermission();
            this.customer = false;
            this.csrf();
            this.getKycPlans();
        }

    }

    csrf() {
        this.userService.csrf().subscribe((success) => {
            this.credentials._csrf = success._csrf;
        }, (error) => {
            console.log("ERROR___>", error.message)
        })
    }

    addCurrency() {
        var nextorder = 1;
        if (this.plansList.length > 0) {
            nextorder = Number(this.plansList[Number(this.plansList.length) - 1].order) + 1;
        }
        this.maxRequirements = 1;
        this.maxFeature = 1;
        this.features = [1];
        this.requirements = [1];
        this.credentials = {
            title: '',
            order: nextorder,
            features: {},
            requirements: {},
            deposit_limit: false,
            deposit_limit_unlimited: true,
            deposit_limit_overall: null,
            deposit_limit_daily: null,
            deposit_limit_monthly: null,
            withdraw_limit: false,
            withdraw_limit_unlimited: true,
            withdraw_limit_overall: null,
            withdraw_limit_daily: null,
            withdraw_limit_monthly: null,
            _id: '',
            _csrf: ''
        };
        this.csrf();
        this.showform = 'edit';
    }

    AddMoreFeature(counter) {
        this.features.push(Number(counter) + 1);
        this.maxFeature = this.findMax(this.features);
    }

    RemoveFeature(counter) {
        var index = this.features.indexOf(counter);
        this.features.splice(index, 1);
        this.maxFeature = this.findMax(this.features);
        delete this.credentials.features[counter];
    }

    AddMoreRequirements(counter) {
        this.requirements.push(Number(counter) + 1);
        this.maxRequirements = this.findMax(this.requirements);
    }

    RemoveRequirements(counter) {
        var index = this.features.indexOf(counter);
        this.requirements.splice(index, 1);
        this.maxRequirements = this.findMax(this.requirements);
        delete this.credentials.requirements[counter];
    }

    getKycPlans() {
        this.kycService.getAllKYCPlan().subscribe(list => {
                this.plansList = list;
                this.planListFlag = true;
            }, (error) => {
                this.notifSer.error(
                    'Error',
                    error.error.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            }
        )
    }

    editCurrency(currid) {
        this.spinnerService.show();
        this.kycService.getKYCPlanById(currid).subscribe(done => {
            this.formlabel = 'Edit Plan';
            this.showform = 'edit';
            this.credentials.title = done.title;
            this.credentials.order = done.order;
            this.credentials.deposit_limit = done.dl;
            this.credentials.deposit_limit_unlimited = done.dl_unlimited;
            this.credentials.deposit_limit_overall = done.dl_overall;
            this.credentials.deposit_limit_daily = done.ddl;
            this.credentials.deposit_limit_monthly = done.mdl;
            this.credentials.withdraw_limit = done.wl;
            this.credentials.withdraw_limit_unlimited = done.wl_unlimited;
            this.credentials.withdraw_limit_overall = done.wl_overall;
            this.credentials.withdraw_limit_daily = done.dwl;
            this.credentials.withdraw_limit_monthly = done.mwl;
            this.credentials._id = done._id;
            /*
            this.credentials.deposit_fee_charges = done.dfc;
            this.credentials.deposit_fee_apply = done.dff;
            this.credentials.withdraw_fee_charges = done.wfc;
            this.credentials.withdraw_fee_apply = done.wff;
             */
            this.features = [];
            this.requirements = [];
            done.features.forEach((item, index) => {
                this.credentials.features[Number(index) + 1] = done.features[index];
                this.features.push(Number(index) + 1);
                this.maxFeature = Number(index) + 1;
            })
            done.requirements.forEach((item, index) => {
                this.credentials.requirements[Number(index) + 1] = done.requirements[index];
                this.requirements.push(Number(index) + 1);
                this.maxRequirements = Number(index) + 1;
            })
            //this.credentials = done;
            this.csrf();
            this.spinnerService.hide();
        }, (err) => {
            this.spinnerService.hide();
            this.notifSer.error(
                '',
                err.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    updatestatus(id, status) {
        this.spinnerService.show();
        this.configService.changeStatus(id, status).subscribe(success => {
            this.getKycPlans();
            this.notifSer.success(
                'Status',
                'Status Updated',
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
            this.spinnerService.hide();
        }, (error) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Status',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }

    submit() {
        this.spinnerService.show();
        this.kycService.AddKYCPlan(this.credentials).subscribe(success => {
                this.getKycPlans();
                this.spinnerService.hide();
                this.showform = 'view';
                this.notifSer.success(
                    'Currency',
                    success.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            }, (error) => {
                this.spinnerService.hide();
                this.notifSer.error(
                    'Currency',
                    error.error.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            }
        )
    }

    findMax(Arr) {
        var result = this.findMinMax(Arr)
        return result[1];
    }

    findMinMax(arr) {
        let min = arr[0], max = arr[0];
        for (let i = 1, len = arr.length; i < len; i++) {
            let v = arr[i];
            min = (v < min) ? v : min;
            max = (v > max) ? v : max;
        }
        return [min, max];
    }

    swap(json) {
        var ret = {};
        for (var key in json) {
            ret[json[key]] = [0];
        }
        return ret;
    }

    swap2(json) {
        var ret = {};
        for (var key in json) {
            ret[json[key]] = 0;
        }
        return ret;
    }

    featureTrack(index, item) {
        return item.name;
    }

    registrationTrack(index, item) {
        return item.name;
    }
}




// WEBPACK FOOTER //
// ./src/app/kycplans/kycplans.component.ts